import { render, staticRenderFns } from "./ResetPwd.vue?vue&type=template&id=08dc3220&scoped=true"
import script from "./ResetPwd.vue?vue&type=script&lang=js"
export * from "./ResetPwd.vue?vue&type=script&lang=js"
import style0 from "./ResetPwd.vue?vue&type=style&index=0&id=08dc3220&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/lyb/工作/个人/leo——im/新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dc3220",
  null
  
)

export default component.exports